import React from 'react'

import { SpinnerIcon } from 'icons'

import css from './style.scss'

const EventsLoading = () => (
  <div className={css.loading} role='status' aria-live='polite'>
    <SpinnerIcon />
    <span className={css.visuallyHidden}>Loading events</span>
  </div>
)

export default EventsLoading
